module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "height": "136",
      "src": "images/ch03.jpg",
      "width": "450"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "color-f898989"
  }, [_c('span', {
    staticClass: "monsterfonts-HouseofTerror"
  }, [_c('strong', [_vm._v("Warning: You might want")])])]), _vm._v(" to hold your nose for this next part. Also, if you’re eating while you read, you might consider finishing that before you continue this, unless you are reading during your school lunch. If so, good for you. Reading is an important part of every meal. (This message paid for by a bribe from your English teacher.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The conditions on Stenchopia were difficult, and many Fluffs could not survive. The rest adapted through the generations, and the Clan changed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back on their home planet, Fluffs absorbed the energy of the sugary atmosphere through the clear hollow tubules of their fur. These tubules also acted as tiny telepathic transmitters that sent their brain waves to those around them. When coupled with their hypnotic swirly eyes, the Fluffs could control the minds of anyone. Once they devoured a creature, they could transmit the entire form of that creature to the mind of anyone they hypnotized. It was a camouflage that made them lethal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, on Stenchopia, the hollow tubules of the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Fluffs’ fur quickly gummed up with swamp slime, so they could not transmit telepathic signals. Even worse, without a sugary atmosphere (which was lacking on Stenchopia), the Fluffs had no food source. They shrank. Many perished. But not all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those Fluffs with bigger noses than the others sniffed in the stinky air of Stenchopia and found traces of energy in the putrid vapors wafting off the stench ponds. It was not much energy, but it was enough to survive. Those survivors passed the genes for their larger noses on to the next generation, who passed them on to the next generation, who . . . blah blah next generation blah blah next blah blah . . . you get the idea. Ultimately, those with the biggest, most efficient noses survived and thrived. Through the generations, their noses became magnificent wobbling schnozzles that could efficiently harvest the power of stench. This was the power of the schnoz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other traits also developed through the generations. The Clan’s feet shrank. Their once clear, hollow fur became dull and gray and coarse. While descendants of the original Clan no longer communicated telepathically using their hollow-tubed fur, they developed an amazing new power of communication: They talked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Actually, that was not very amazing. You probably do it all the time. But you probably can’t control anybody’s mind with your brain. The Clan could. The pathways connecting their brains and their schnozzles developed into a sophisticated network capable of transmitting telepathic signals via smell. Smellepathy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smellepathic signals sent images, feelings, and ideas to the brains of others, leaving them at the mercy of the large-schnozzled Clan. When added to their hypnotic swirly-eyed gaze, this power made the Clan unstoppable. Like their cousins, they used the identity of devoured creatures as camouflage and tricked the planet’s animals into doing things for them, like becoming snacks. Although the Clan gathered energy through their enormous schnozzles, they still loved a good snack, in the same way that people enjoy popcorn. It has no nutritional value, but oh, that crunch!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so it was that over many generations, the Clan became a completely new race of fluffy bunnies. Very, very stinky bunnies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They became the Fierce, Obnoxious, Odoriferous Furballs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Foofs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the rest—as they say—is history.")]), _vm._v(" "), _c('div', {
    staticClass: "break-b"
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    staticClass: "monsterfonts-spookhouse"
  }, [_c('strong', [_vm._v("Table 1: Know Your Foof,")])]), _vm._v(" taken from "), _c('em', [_vm._v("The Illustrated Guide to Fluffs and Other Space Creatures You Don’t Want to Meet")]), _vm._v(", by Professor Donald J. Dewdy. (Work unpublished.) Perhaps you remember a similar chart in "), _c('em', [_vm._v("Attack of the Fluffy Bunnies")]), _vm._v(". In that chart, Professor Donald J. Dewdy offered a comparison between the Fierce, Large, Ugly, and Ferocious Furballs (Fluffs) and simple Earth rabbits or, as you might call them, bunnies. In the following table, Professor Dewdy offers a comparative analysis between the Fierce, Obnoxious, Odoriferous Furballs (Foofs) and chocolate. No one knows why Professor Dewdy chose to compare aliens with a delicious treat instead of something useful like a human or another alien, but we are sure that he had a good reason. Or maybe he was just hungry. In the end, it doesn’t matter. What does matter is that if you wish to have a delicious warm drink, melt chocolate into a glass of hot milk, stir, and add whipped cream. Do not melt a Foof in a glass of hot milk, stir, or add whipped cream. It wastes the whipped cream and annoys the Foof.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletitle"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('strong', [_vm._v("TABLE 1: KNOW YOUR FOOF")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "35%"
    }
  })]), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablecp"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablecp"
  }, [_vm._v("CHOCOLATE")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablecp"
  }, [_vm._v("FOOFS")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec1p"
  }, [_vm._v("Genus and species")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("Chocolate is not a living thing and does not have a genus or species. It is, however, made from the seeds of the cacao tree or cocoa tree. Actually, they are the same tree, but one name is for people who like the letter “a” while the other is for people who prefer the letter “o.” People who love the letter “v” are weirdos who probably don’t like chocolate at all.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec1p"
  }, [_c('em', [_vm._v("Lepus foofilicious")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec1p"
  }, [_vm._v("Habitat")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("On top of cakes. In flat bars wrapped in thin silver foil. Swimming in cups of hot milk with floating islands of whipped cream. Yum.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("The putrescent slime ponds of Stenchopia in the Stinkpit System")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec1p"
  }, [_vm._v("Diet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("Chocolate and diets are like matter and antimatter. They cancel each other out in a gigantic explosion, after which nothing matters.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("Foofs ingest “nutrients” by inhaling the gaseous bubbles that burst forth from the putrid ponds on their planets.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletp"
  }, [_vm._v("When they receive enough nutrition, the Foofs’ extreme metabolism gives them ridiculous strength and lets them grow to enormous heights of 7 feet or more.")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "35%"
    }
  })]), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablecp"
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablecp"
  }, [_vm._v("CHOCOLATE")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablecp"
  }, [_vm._v("FOOFS")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec1p"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Communication")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("It is a basic law of the universe that inanimate objects cannot communicate with living beings. Because of this law (also known as the Hershey’s Principle), chocolate cannot communicate with people. It does not have—wow . . . is that a bonbon?—the ability to in any way influence—must have bonbon—thought patterns and . . . yummmmmmm.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletp"
  }, [_vm._v("Correction: Chocolate possesses the most powerful property for communication in the universe. It is delicious.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("Smellepathy: Foofs control the brains of other creatures via smell. Smellepathic signals send images, feelings, and ideas to the brains of creatures under their control.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletp"
  }, [_vm._v("Under rare and very, very, VERY smelly conditions, the Foofs’ brains heat to a level that fuses the neural-telepathic pathways, making the creatures permanently under the Foofs’ control.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletp"
  }, [_vm._v("Smellepathy controls their prey’s brain via the olfactory nerves. The word “olfactory,” which means smelling, should not be confused with “old factory,” because that would be silly.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletp"
  }, [_vm._v("To enhance this process, the Foofs emit a “fragrance” that is sometimes confused with the sweet smell of roses outside a perfume factory on a perfect summer morning after a lovely rain shower.")]), _vm._v(" "), _c('p', {
    staticClass: "tabletp"
  }, [_vm._v("Ha ha ha ha ha. That’s a good one.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablec1p"
  }, [_vm._v("Predators")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("Everyone who ever lived. And their grandmothers. Really. How could you not know that?")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablep"
  }, [_vm._v("Yes, they are.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0